// BusyButton.module.scss
// A blocked BusyButton keeps pointer events (pe-auto) so its `title` shows on
// hover, but that also lets `:active` press colours, the pointer cursor and the
// link variant's hover colour apply. `.btn:first-child:active` outscores
// `.btn.disabled` at (0,3,0) vs (0,2,0). `.btn:hover` and `.btn.disabled` tie
// at (0,2,0) and `.btn.disabled` wins for the primary variant, but
// `.btn-link:hover` is declared after `.btn.disabled`, so the link variant
// needs the module pin. Pin the `:active` colours, the link hover colour and
// the cursor back on top with matching or higher specificity than Bootstrap's
// own rules.

.blocked {
  &:global(.btn.disabled) {
    cursor: default;
  }

  &:global(.btn.disabled):active {
    color: var(--bs-btn-disabled-color);
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
  }

  &:global(.btn-link.disabled):hover {
    color: var(--bs-btn-disabled-color);
  }
}
